/**
 * Challenges Administration Page
 * Wraps the existing Admin Challenges component in SubscriptionLayout
 */

import React from 'react';
import SubscriptionLayout from '../../components/subscription/SubscriptionLayout';
import AdminChallenges from '../../admin/Challenges';

const ChallengesPage: React.FC = () => {
  return (
    <SubscriptionLayout>
      <AdminChallenges />
    </SubscriptionLayout>
  );
};

export default ChallengesPage;


